import { FC } from 'react';

import { ICartItemPicture } from './types';

const CartItemPicture: FC<ICartItemPicture> = () => null;

export default CartItemPicture;
